module.exports = __webpack_public_path__ + "media/soundtrack.9c83ec64.mp3";